import { Divider } from '@material-ui/core';
import React from 'react';
import './FilterSummary.css';

function numberWithCommas(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function FilterSummary({ count, type }) {

	return (
		<div className="filterSummary">
			<div className="filterSummary__count">
				( {numberWithCommas(count)} {type} )
			</div>
			<Divider />
			<div className="filterSummary__label">filter your results</div>
			<div className="filterSummary_arrow"></div>
		</div>
	);
}

export default FilterSummary;
